import { createStore, applyMiddleware } from 'redux'
import reducer from 'reducers/online'

const logger = store => next => action => {
  console.group(action.type)
  console.info('dispatching', action)
  const result = next(action)
  console.log('next state', store.getState())
  console.groupEnd()
  return result
}

const initialState = {
  modal: { id: null, open: false },
  errorMessage: null,
  notifications: []
}

const middleware = []
if (process.env.NODE_ENV === 'development') {
  middleware.push(logger)
}

const store = createStore(reducer, initialState, applyMiddleware(...middleware))

export default store
